import { render, staticRenderFns } from "./FieldYoutubeLink.vue?vue&type=template&id=79ff5dac&scoped=true"
import script from "./FieldYoutubeLink.vue?vue&type=script&lang=js"
export * from "./FieldYoutubeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff5dac",
  null
  
)

export default component.exports